import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { IconColor, IconType, IconSize } from '../../../common/constants';

@Component({
  selector: 'ui-tooltip-alert',
  templateUrl: './tooltip-alert.component.html',
  styleUrls: ['./tooltip-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipAlertComponent {
  @Input() tooltipText: string;
  @Input() tooltipPosition: TooltipPosition = 'above';
  @Input() iconType: IconType = IconType.AlertWarningFilled;
  @Input() iconSize: IconSize = IconSize.Small;
  @Input() iconColor: IconColor = IconColor.Yellow;
  iconColorsMap: Record<IconColor, 'tw-text-black' | 'tw-text-yellow-500'> = {
    [IconColor.Black]: 'tw-text-black',
    [IconColor.Yellow]: 'tw-text-yellow-500',
  };
  iconSizesMap: Record<IconSize, 14 | 16 | 20> = {
    [IconSize.Small]: 14,
    [IconSize.Medium]: 16,
    [IconSize.Large]: 20,
  };
}
